import { clsx, type ClassValue } from 'clsx'
import { customAlphabet } from 'nanoid'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalize(str: string) {
  if (!str || typeof str !== 'string') return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const generateGifCode = (len = 10) => {
  const only_alpha =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890'

  const nano = customAlphabet(only_alpha, len)
  return nano()
}

export function replaceMiddleChars(str: string) {
  if (str.length <= 2) {
    return str.split('').join(',').replace(',', '*****') // 字符串长度小于等于2，无需替换
  }

  const firstChar = str[0]
  const lastChar = str[str.length - 1]
  const middleChars = '*'.repeat(Math.max(0, str.length - 2))

  return `${firstChar}${middleChars}${lastChar}`
}

export function nFormatter(num: number, digits?: number) {
  if (!num) return '0'
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value
    })
  return item
    ? (num / item.value).toFixed(digits || 1).replace(rx, '$1') + item.symbol
    : '0'
}

export const truncate = (str: string | null, length: number) => {
  if (!str || str.length <= length) return str
  return `${str.slice(0, length - 3)}...`
}

export function constructMetadata({
  title = 'Suite - 以会员需求为中心，Suite营销全解决方案',
  description = 'Suite是一款SaaS产品,它可以帮助企业高效管理会员信息,并提供会员体验营销、推广活动、数据报表等一站式的全面的营销解决方案,助力企业提升转化率。',
  image = 'https://dub.co/_static/thumbnail.png',
  icons = '/favicon.ico',
  noIndex = false,
}: {
  title?: string
  description?: string
  image?: string
  icons?: string
  noIndex?: boolean
} = {}): any {
  return {
    title,
    description,
    openGraph: {
      title,
      description,
      images: [
        {
          url: image,
        },
      ],
    },
    twitter: {
      card: 'summary_large_image',
      title,
      description,
      images: [image],
      creator: '@koyaguo',
    },
    icons,
    // metadataBase: new URL(HOME_DOMAIN),
    themeColor: '#FFF',
    ...(noIndex && {
      robots: {
        index: false,
        follow: false,
      },
    }),
  }
}
